import { DeleteOutline } from '@mui/icons-material';
import {
    Box,
    Card,
    CircularProgress,
    IconButton,
    styled,
    Typography,
} from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';
import AppAvatar from 'components/avatars/AppAvatar';
import FlexBox from 'components/flexbox/FlexBox';
import { H6, Tiny } from 'components/Typography';
import DeleteOutlined from 'icons/DeleteOutlined';
import UploadOnCloud from 'icons/UploadOnCloud';
import React from 'react';
import { useDropzone } from 'react-dropzone';
// import { lightTheme } from "../../../constants";
const UploadImagesWrapper = styled(Box)(({ theme }) => ({
    overflow: 'hidden',
    borderRadius: '8px',
    '&::after': {
        top: 0,
        left: 0,
        opacity: 0,
        width: '100%',
        content: '""',
        height: '100%',
        position: 'absolute',
        transition: 'opacity 0.3s',
        backgroundColor: theme.palette.secondary[300],
    },
    '&:hover::after': {
        opacity: 0.7,
    },
    '&:hover .MuiButtonBase-root.MuiIconButton-root': {
        visibility: 'visible',
    },
}));
const DeleteIconButton = styled(IconButton)(({ theme }) => {
    const bgColor = 'white';
    return {
        top: 10,
        right: 10,
        zIndex: 1,
        padding: '4px',
        visibility: 'hidden',
        position: 'absolute',
        backgroundColor: bgColor,
        transition: 'visibility 0.2s',
        '&:hover': {
            backgroundColor: bgColor,
        },
    };
}); // --------------------------------------------------------------

// --------------------------------------------------------------
const FileUpload = ({ onDrop, error, handleRemove, file, fileName }) => {
    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            'application/pdf': ['.pdf'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                ['.docx'],
            'image/jpeg': ['.jpeg', '.jpg'],
        },
        maxSize: 5000000,
        onDrop,
    });
    return (
        <Card
            sx={{
                padding: 3,
            }}
        >
            {file ? (
                <>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <CircularProgress color="success" />
                        <Tiny fontWeight={600}>
                            Please wait, your file is being processing ...
                        </Tiny>
                    </Box>
                </>
            ) : (
                <Box
                    {...getRootProps({
                        className: 'dropzone',
                    })}
                    sx={{
                        padding: 3,
                        cursor: 'pointer',
                        textAlign: 'center',
                    }}
                >
                    <UploadOnCloud
                        sx={{
                            fontSize: 38,
                            color: 'text.disabled',
                        }}
                    />
                    <Tiny fontWeight={600}>Drop your file here or</Tiny>
                    <H6 fontSize={12} color="primary.main">
                        Click to browse
                    </H6>
                    <FormHelperText
                        sx={{ color: 'error.main', textAlign: 'center' }}
                    >
                        {error
                            ? error
                            : 'Permitted file types: .pdf, .docx, .jpg, .jpeg'}
                    </FormHelperText>
                    <input
                        {...getInputProps()}
                        placeholder="Select click to browse"
                    />
                </Box>
            )}

            {fileName && (
                <FlexBox gap={2} mt={2}>
                    <DeleteIconButton onClick={() => handleRemove()}>
                        <Typography>{fileName}</Typography>
                        <DeleteOutline
                            sx={{ color: 'text.disabled', fontSize: 17 }}
                        />
                    </DeleteIconButton>
                </FlexBox>
            )}
        </Card>
    );
};

export default FileUpload;
